const html = document.documentElement;
const body = document.body;
const header = document.querySelector('#header');
const loader = document.querySelector('#loader');
const transition = document.querySelector('#transition');
const main = document.querySelector('#main');

export { html, body, header, loader, transition, main };
